<template>
  <div>
    <v-card class="py-3 mb-4">
      <v-card-title>
        <span class="title">
          {{ $t('reports.recipesTracking.title') }}
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="subheading">
          {{ $t('reports.recipesTracking.description') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <span class="body-2">
          {{ $t('reports.salesAndCosts.chooseDateRange') }}
        </span>
        <div class="d-flex justify-center">
          <v-date-picker
            v-model="selectedDates"
            ref="picker"
            color="primary"
            range
            :first-day-of-week="1"
            :allowed-dates="allowedDates"
            @input="orderDateRange"
            reactive
            no-title
            :locale="locale">
          </v-date-picker>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center">
        <v-btn @click="download" color="primary darken-1" :disabled="isDisabled">
          {{ loading ? $t('reports.downloading') : $t('reports.download') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="3000">
      <span class="body-1">
        {{ snackbarText }}
      </span>
    </v-snackbar>
  </div>
</template>

<script>
import getLocale from '@/lang/locale'

export default {
  name: 'RecipesTracking',
  data () {
    return {
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackBarColor: null,
      selectedDates: []
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    isDisabled () {
      return this.selectedDates.length !== 2 || this.loading
    }
  },
  mounted () {
    const today = new Date()
    this.month = `${today.getFullYear()}-${(today.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`
  },
  methods: {
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    orderDateRange () {
      this.selectedDates.sort((a, b) => new Date(a) - new Date(b))
    },
    showSnackBar (message, success) {
      this.snackBarColor = success ? 'success darken-1' : 'error darken-1'
      this.snackbarText = message
      this.snackbar = true
    },
    downloadFile (response) {
      const link = document.createElement('a')
      const fileName = `reporte-seguimiento-recetas.xlsx`
      link.href = 'data:application/octet-stream;base64,' + response
      link.download = fileName
      link.click()
      this.loading = false
    },
    resetCalendar () {
      this.selectedDates = []
    },
    async download () {
      this.loading = true
      try {
        const response = await this.$api.post(`/v1/restaurants/${this.restaurant._id}/reports/recipes-tracking`, {
          startDate: this.selectedDates[0],
          endDate: this.selectedDates[1]
        })
        this.downloadFile(response)
        this.showSnackBar(this.$t('reports.successfulDownload'), true)
      } catch (error) {
        this.showSnackBar(error.message, false)
        this.loading = false
      }

      this.resetCalendar()
    }
  }
}
</script>
